import styles from './Backdrop.module.scss';

/**
 * Фон оболочки: два размытых круга — фирменная деталь (концепт, §8).
 *
 * Вынесен в отдельный слой с `position: fixed`, чтобы содержимое не
 * пересчитывало blur при каждой перерисовке. Круги медленно дрейфуют —
 * незаметно в моменте, но фон живой. При prefers-reduced-motion стоят.
 */
export function Backdrop() {
  return (
    <div className={styles['backdrop']} aria-hidden="true">
      <span className={styles['backdrop__orb--accent']} />
      <span className={styles['backdrop__orb--info']} />
    </div>
  );
}
